import React from 'react';
import clsx from 'clsx';

export const Badge = ({ variant = 'default', className, children, ...props }) => {
  const variants = {
    default: 'bg-[var(--muted)] text-[var(--fg)]',
    primary: 'bg-[var(--primary)]/10 text-[var(--primary)]',
    success: 'bg-[var(--success)]/10 text-[var(--success)]',
    warning: 'bg-[var(--warning)]/10 text-[var(--warning)]',
    danger: 'bg-[var(--danger)]/10 text-[var(--danger)]',
    info: 'bg-[var(--info)]/10 text-[var(--info)]',
  };
  
  return (
    <span
      className={clsx(
        'inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium',
        variants[variant],
        className
      )}
      {...props}
    >
      {children}
    </span>
  );
};